import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled, { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";

const PrimaryBackgroundContainer = tw(Container)`-mx-8 px-8 bg-primary-100 text-gray-100`;

const HeadingContainer = tw.div``;
const Subheading = tw(SubheadingBase)`text-center text-gray-100 mb-4`;
const Heading = tw(SectionHeading)``;
const Description = tw(SectionDescription)`mx-auto text-center text-gray-300`;

const FaqsContainer = tw.div`mt-10 sm:mt-16 w-full flex-1 lg:flex justify-between items-start max-w-screen-lg mx-auto`;
const FaqsColumn = tw.div`w-full lg:max-w-lg lg:mr-12 last:mr-0`;
const Faq = tw.div`select-none cursor-pointer border-b-2 border-primary-300 hover:border-primary-500 transition-colors duration-300 py-6`;
const Question = tw.div`flex justify-between items-center`;
const QuestionText = tw.div`text-sm sm:text-lg font-semibold tracking-wide`;
const QuestionToggleIcon = styled(motion.span)`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const Answer = tw(motion.div)`hidden text-sm font-normal mt-4 text-gray-300`;

export default ({
  subheading = "",
  heading = "Perguntas Frequentes",
  description = "Tire suas dúvidas sobre como a Trataz pode transformar sua prática profissional.",
  faqs = [
    {
      question: "Como funciona o período de teste gratuito?",
      answer:
        "Oferecemos 30 dias gratuitos para você testar todos os recursos da plataforma com até 5 pacientes. Sem compromisso, sem cartão de crédito necessário para começar."
    },
    {
      question: "A Trataz funciona para qualquer especialidade?",
      answer:
        "A Trataz foi desenvolvida especificamente para fonoaudiologia e odontologia, com recursos otimizados para essas áreas. Nossos materiais didáticos e ferramentas são personalizados para essas especialidades."
    },
    {
      question: "Os pacientes precisam pagar para usar o app?",
      answer:
        "Não! Seus pacientes têm acesso gratuito ao aplicativo móvel e a todos os materiais que você compartilhar. Eles só precisam baixar o app e usar o código que você fornecer."
    },
    {
      question: "Como funciona o suporte técnico?",
      answer:
        "Oferecemos suporte por email, WhatsApp e chat ao vivo. Profissionais dos planos pagos têm atendimento prioritário com resposta em até 2 horas durante horário comercial."
    },
    {
      question: "É seguro para dados dos pacientes?",
      answer:
        "Sim! Seguimos rigorosamente a LGPD e todas as informações são criptografadas e armazenadas com segurança na nuvem. Temos certificações de segurança e backup automático."
    },
    {
      question: "Posso criar meus próprios materiais na plataforma?",
      answer:
        "Sim! Você pode gravar vídeos personalizados, criar exercícios específicos e desenvolver conteúdos exclusivos para seus pacientes, além de usar nossa biblioteca de materiais prontos."
    },
    {
      question: "Como os lembretes automáticos funcionam?",
      answer:
        "A plataforma envia lembretes por WhatsApp e email nos horários que você configurar. Os pacientes recebem notificações sobre exercícios, consultas e marcos importantes do tratamento."
    },
    {
      question: "Posso acompanhar o progresso dos meus pacientes?",
      answer:
        "Sim! Você tem acesso a relatórios detalhados sobre engajamento, progresso dos exercícios, frequência de uso e feedback dos pacientes, tudo em tempo real."
    }
  ]
}) => {
  const faqCol1 = [];
  const faqCol2 = [];
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  faqs.map((faq, index) => {
    const renderedFaq = (
      <Faq key={index} onClick={() => toggleQuestion(index)}>
        <Question>
          <QuestionText>{faq.question}</QuestionText>
          <QuestionToggleIcon
            variants={{
              collapsed: { rotate: 0 },
              open: { rotate: -180 }
            }}
            initial="collapsed"
            animate={activeQuestionIndex === index ? "open" : "collapsed"}
            transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <ChevronDownIcon />
          </QuestionToggleIcon>
        </Question>
        <Answer
          variants={{
            open: { opacity: 1, height: "auto", marginTop: "16px", display: "block" },
            collapsed: { opacity: 0, height: 0, marginTop: "0px", display: "none" }
          }}
          initial="collapsed"
          animate={activeQuestionIndex === index ? "open" : "collapsed"}
          transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
        >
          {faq.answer}
        </Answer>
      </Faq>
    );

    if (index % 2 === 0) faqCol1.push(renderedFaq);
    else faqCol2.push(renderedFaq);

    return null;
  });
  return (
    <PrimaryBackgroundContainer>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </HeadingContainer>
        <FaqsContainer>
          <FaqsColumn>{faqCol1}</FaqsColumn>
          <FaqsColumn>{faqCol2}</FaqsColumn>
        </FaqsContainer>
      </ContentWithPaddingXl>
    </PrimaryBackgroundContainer>
  );
};
